var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"25","height":"25","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12.5 0C5.575 0 0 5.575 0 12.5S5.575 25 12.5 25 25 19.425 25 12.5 19.425 0 12.5 0zm6.64 6.036l1.537 1.46L9.69 20.346l-5.633-7.483 2.265-1.957 3.38 5.176 8.811-10.674.628.628z","fill":"#843CAE","fill-rule":"evenodd"}})])};var toString = function () {return "/tmp/build_a351a41a/src/components/Complete.svg"};module.exports = { render: render, toString: toString };


//////////////////
// WEBPACK FOOTER
// ./src/components/Complete.svg
// module id = 459
// module chunks = 1